import React, { useState } from 'react'
import { connect } from 'react-redux'
import { storageThumbUrl } from '../../firebase'
import { colorToCss } from './discModel'

// Base layer is the disc's colour (or a neutral glyph when it has none); the disc photo,
// keyed by the disc uuid, is overlaid on top. If the photo fails to load (or the disc has
// no uploaded image) the overlay is hidden and the colour/glyph behind it shows through.
function DiscThumb({ disc = {}, uuid }) {
  const [failed, setFailed] = useState(false)

  const color = colorToCss(disc.c)
  const src =
    uuid && disc.uuid
      ? storageThumbUrl(`user/${uuid}/disc/${disc.uuid}/thumb.jpeg`)
      : null

  return (
    <span className="thumb">
      {color ? (
        <span
          className="disc-thumb thumb-fallback disc-thumb--color"
          style={{ backgroundColor: color }}
        />
      ) : (
        <span className="disc-thumb thumb-fallback disc-thumb--empty">
          <i className="bi-record-circle" />
        </span>
      )}
      {src && !failed && (
        <img
          className="disc-thumb thumb-image"
          src={src}
          alt="Disc"
          onError={() => setFailed(true)}
        />
      )}
    </span>
  )
}

const mapStateToProps = (state) => ({
  uuid: state.auth.uuid,
})

export default connect(mapStateToProps)(DiscThumb)
